import { FC } from "react";
import { useTranslation } from "react-i18next";
import { TrashIcon } from "@heroicons/react/24/outline";
import MultiStockCard from "components/Quasi/MultiStockCard/MultiStockCard";
import {
  BookingDataType,
  BookingHolidayPackage,
  isHolidayPackage,
} from "data/interfaces";
import HolidayPackagePanelGuard from "./HolidayPackagePanelGuard";

interface Props {
  booking: BookingDataType;
  onRemoveById: (id: string | number) => void;
  onRemoveByItem: (item: BookingDataType) => void;
  onSendRequest: (item: BookingDataType) => Promise<void>;
  onChangeDates: (item: BookingDataType) => void;
  isSendingRequest: boolean;
  onProblematicChange: (id: string | number, isProblematic: boolean) => void;
}

const HolidayPackageCartRow: FC<Props> = ({
  booking,
  onRemoveById,
  onRemoveByItem,
  onSendRequest,
  onChangeDates,
  isSendingRequest,
  onProblematicChange,
}) => {
  const { t } = useTranslation("translation");

  if (!isHolidayPackage(booking.item)) {
    return null;
  }
  const hpBooking = booking as BookingHolidayPackage;
  const pkg = hpBooking.item;
  const uuid = String(pkg.package_uuid);

  const galleryImages = pkg.gallery_images || [];
  const images =
    galleryImages.length > 0
      ? galleryImages
      : pkg.cover_image
        ? [pkg.cover_image]
        : [];

  return (
    <div id={`cart-item-${hpBooking.id}`} className="mb-4">
      <MultiStockCard
        id={uuid}
        cover={pkg.cover_image || ""}
        annotation={pkg.category ? `${pkg.category}` : "Pacchetto Vacanze"}
        images={images}
        title={pkg.name}
        address={pkg.location || ""}
        mood={pkg.mood}
        price={Number(pkg.price || 0) + Number(hpBooking.additional_fees || 0)}
        href={`/holiday-package/${uuid}`}
        loading={false}
      >
        <span
          className="flex flex-row items-center justify-center text-red-500 gap-2 bg-neutral-100 dark:bg-neutral-800 dark:text-neutral-200 py-2 px-2 rounded-full cursor-pointer hover:opacity-80 w-[8rem]"
          onClick={() => onRemoveById(hpBooking.id)}
        >
          <TrashIcon className="h-5 w-5" />
          <span>{t("translation:myTrip.actions.remove")}</span>
        </span>
      </MultiStockCard>
      <HolidayPackagePanelGuard
        booking={booking}
        onSendRequest={onSendRequest}
        onRemove={onRemoveByItem}
        onChangeDates={onChangeDates}
        isSendingRequest={isSendingRequest}
        onProblematicChange={onProblematicChange}
      />
    </div>
  );
};

export default HolidayPackageCartRow;
